import { Form, InputNumber } from 'antd';
import React from 'react'
import { numberWithCommas } from '../../utils/number';

const InputNumberUC = (props) => {
    const {
        name,
        label,
        isCustomError = false,
        labelError = null,
        showLabel = true,
        onChange,
        values,
        required,
        disabled,
        placeholder = 'กรุณากรอก' + label,
        showPlaceholder = true,
        ...prop } = props;

    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{ required: true, message: 'กรุณากรอก ' + label }] : ''}
                initialValue={values ? numberWithCommas(values) : null}
                help={(isCustomError && required) ? labelError : null}
            >
                <InputNumber
                    {...prop}
                    style={{ width: '100%' }}
                    disabled={disabled}
                    onChange={onChange}
                    placeholder={showPlaceholder ? placeholder : ''}
                    className="input-number-rc input-text-rc"
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    min={0}
                    max={10000000}
                />
            </Form.Item>
        </>
    )
}

export default InputNumberUC